let config = {
    // "BASE_API": "http://221.207.19.42:7016/",
    "BASE_API": "https://hyauction-api.wbsystem.cn/",
    "IMG_URL": "http://oss.current.rfidhint.com/",
    "SYS_Name": "海晏活畜拍卖交易平台",
    // "WEB_Socket": "ws://47.108.253.52:7022/oTpJw_=8",
    "WEB_Socket": "wss://hyauction-ws.wbsystem.cn/ws", //双工通讯地址
    // "VIDEO_URL": "https://srs-live.livel.top/rtp/",
    // "VIDEO_TYPE": "/hls.m3u8",
    "VIDEO_TYPE": ".live.mp4",
    // "LIVEIMG_URL": "http://srs-live.livel.top/static/snap/", //直播视频封面图
    "LIVEIMG_TYPE": ".jpg",
}
module.exports = {
    config
}